import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

export const useMinStartBarePeriodDate = (startBarePeriodDate: number) => {
  const [minStartBarePeriodDate, setMinStartBarePeriodDate] = useState<Dayjs>(
    dayjs(`${startBarePeriodDate}`).add(1, "day")
  );
  useEffect(() => {
    setMinStartBarePeriodDate(dayjs(`${startBarePeriodDate}`).add(1, "day"));
  }, [startBarePeriodDate]);
  return [minStartBarePeriodDate];
};
